import {Biscuit, getAllUrlParams} from "../../../../../utils";
import React,{useEffect, useState} from "react";
import {
    clientActions,
    matrixFieldsActions,
    membershipTypeActions,
    messagesActions,
    userActions,
    useSelector
} from "inbooma-api";
import t from "../../../../helpers/t";
import showNotification from "../../../../helpers/showNotification";
import {$, moment} from "../../../../../../vendor";
import MessageSidebar from "./MessageSidebar";
import InboomaSubmenu from "../../../../components/InboomaSubmenu";
import SortNav from "../../../../components/SortNav";
import {isViewVisible} from "../../../../../utils/ViewSettings";
import MessagesList from "./MessagesList";
import Loader from "../../../../components/Loader";
import MessageEdit from "../MessageEdit";
import MessageView from "./MessageView";

const MessagesView = (props) => {
    const { dispatch, params, returnPath } = props;
    const currentUrl = new URL(window.location.href);
    const language = Biscuit.get('user.lang').replace('-','_');
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href);
    const paginationLimit = 40;
    const [pagination,setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });
    const _queryState = {
        timeStamp: 0,
        value: ""
    }
    let mainMenu = document.getElementById('inb-main-menu');
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector('.l-users')) {
        if (mainMenu.querySelector('.active') != null) mainMenu.querySelector('.active').classList.remove('active');
        mainMenu.querySelector('.l-users').classList.add('active');
    }
    const [filters, setFilters] = useState({
        'find': '',
        'sort': 'created',
        'direction': 'desc',
        'limit': paginationLimit,
        'page' : pagination.current_page,
        ...allUrlParams
    });
    const _messages = useSelector(state => state.messages_data.getMessages);
    const _message = useSelector(state => state.messages_data.getMessage);
    const _messageSummary = useSelector(state => state.messages_data.getMessageSummary);
    const _matrixFields = useSelector(state => state.matrix_fields_data.matrixFields);
    const _client = useSelector(state => state.client_data.client);
    const _users = useSelector(state => state.users_data.users);
    const _userGroup = useSelector(state => state.membership_types_data.membershipType);
    const _userGroups = useSelector(state => state.membership_types_data.membershipTypes);
    const [toggleMultipleRecipients, setToggleMultipleRecipients]= useState(false);
    const [usersPending,setUsersPending] = useState(false);
    const [userGroupPending,setUserGroupPending] = useState(false);
    const [userGroupsPending,setUserGroupsPending] = useState(false);
    const [users, setUsers] = useState([]);
    const _deleteMessage = useSelector(state => state.messages_data.deleteMessage);
    const [messageSummaryPending, setMessageSummaryPending] = useState(false);
    const [messageSummary,setMessageSummary] = useState([]);
    const [messages,setMessages] = useState([]);
    const [message,setMessage] = useState(null);
    const [userGroup,setUserGroup] = useState(null);
    const [userGroups,setUserGroups] = useState(null);
    const [messagesPending,setMessagesPending] = useState(false);
    const [messagePending,setMessagePending] = useState(false);
    const [deleteMessagePending, setDeleteMessagePending] = useState(null);
    const [toggleMessage, setToggleMessage] = useState(false);
    const [clientPending,setClientPending] = useState(false);
    const [client, setClient] = useState(null);
    const [initialized,setInitialized] = useState(false);
    const [multipleRecipientList,setMultipleRecipientList] = useState([]);

    useEffect(() => {
        if(initialized || messagesPending || clientPending || messagePending || messageSummaryPending || userGroupsPending){
            return;
        }
        dispatch(matrixFieldsActions.getMatrixFields(
            {
                filter: {
                    client_id: Biscuit.get('user.client_id'),
                    active_be: 1,
                    webname: 'default'
                },
                parameters: {
                    headers: {
                        "Accept-Language": language
                    }
                }
            }
        ));
        dispatch(clientActions.getClient({
            client_id: Biscuit.get('user.client_id'),
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setClientPending(true);
        dispatch(membershipTypeActions.getMembershipTypes({
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setUserGroupsPending(true);
        let requestFilter = {...filters};
        requestFilter = {...requestFilter, page: pagination.current_page};
        requestFilter = {...requestFilter, limit: paginationLimit};
        requestFilter = {...requestFilter, ...allUrlParams};
        dispatch(messagesActions.getMessages({
            token: Biscuit.get('token'),
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setMessagesPending(true);
        dispatch(messagesActions.getMessageSummary({
            token: Biscuit.get('token'),
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setMessageSummaryPending(true);
        dispatch(userActions.getUsers({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1,
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setUsersPending(true);
        if(params.messageId !== null){
            setMessage(null);
            dispatch(messagesActions.getMessageResetData())
            dispatch(messagesActions.getMessage({
                token: Biscuit.get('token'),
                id: params.messageId,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setMessagePending(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkInitialized = () => {
        if(!messagesPending && !messagePending && !clientPending && !deleteMessagePending && !messageSummaryPending &&  !userGroupPending && !userGroupsPending){
            setInitialized(true);
        }
    }

    useEffect(() => {
        if(_messages.success === '' || !messagesPending){
            return;
        }
        if(_messages.success === true){
            setMessages(_messages.data);
            setPagination(_messages.pagination);
        }
        setMessagesPending(false);
        checkInitialized();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_messages]);

    useEffect(() => {
        if(_message.success === '' || !messagePending){
            return;
        }
        if(_message.success === true){
            setMessage(_message.data);
        }
        setMessagePending(false);
        checkInitialized();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_message]);

    useEffect(() => {
        if(_userGroups.success === '' || !userGroupsPending){
            return;
        }
        if(_userGroups.success === true){
            setUserGroups(_userGroups.data);
        }
        setUserGroupsPending(false);
        checkInitialized();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_userGroups]);

    useEffect(() => {
        if(_userGroup.success === '' || !userGroupPending){
            return;
        }
        if(_userGroup.success === true){
            setUserGroup(_userGroup.data);
        }
        setUserGroupPending(false);
        checkInitialized();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_userGroup]);

    useEffect(() => {
        if(_users.success === '' || !usersPending){
            return;
        }
        if(_users.success === true){
            setUsers(_users.data);
        }
        setUsersPending(false);
        checkInitialized();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_users]);

    useEffect(() => {
        if (messageSummaryPending === false || _messageSummary.success === "") {
            return;
        }
        if (_messageSummary.success === true) {
            setMessageSummary(_messageSummary.data);
        } else {
            console.log("Failed fetching message summary!");
        }
        setMessageSummaryPending(false);
        checkInitialized();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_messageSummary]);

    useEffect(() => {
        if (_client.success === "" || clientPending === false) {
            return;
        }

        if (_client.success === true) {
            setClient(_client.data);
        } else {
            console.log("Failed getting client!");
        }
        setClientPending(false);
        checkInitialized();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_client]);

    useEffect(() => {
        if (_deleteMessage.success === "" || deleteMessagePending === null) {
            return;
        }

        if (_deleteMessage.success === true) {

            showNotification('success',null,"", t('delete message successfully'));
            let clone = [...messages];
            clone.splice(deleteMessagePending,1);
            setMessages(clone);

        } else if (_deleteMessage.success === false) {
            showNotification('warning', null, "", t('delete message unsuccessfully'));
        }
        setDeleteMessagePending(null);
        checkInitialized();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_deleteMessage]);


    const onSearchbarChanged = (ev) => {

        let query;
        if(typeof ev.target !== 'undefined') {
            query = ev.target.value.toLowerCase();
        } else {
            query = '';
        }
        searchParams.delete('q');
        if(query !== '') {
            searchParams.set('q', query);
        }
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);

        const minLength = 3;

        if (query.length >= minLength) {                                    // work user search only for values bigger or equal to the minimum length

            setTimeout(function () {

                var diff = Number(moment().format('x')) - _queryState.timeStamp;
                if (diff > 700 && _queryState.value == query) {                  // no changes after the last 700 ms -> user finished input -> start request
                    props.dispatch(messagesActions.getMessages({
                            token: Biscuit.get('token'),
                            filter: {
                                ...filters,
                                'q': query
                            },
                            parameters: {
                                headers: {
                                    'Accept-Language': language,
                                    'Content-Language': language
                                }
                            }
                        }));
                        setFilters({
                            ...filters,
                            'q': query
                        });
                }
            },800);
        } else if (filters.q !== undefined) {
            // reset filter when query was active
            var clone = {...filters};
            delete clone.q;
            setFilters(clone);

                props.dispatch(messagesActions.getMessages({
                    token: Biscuit.get('token'),
                    filter: {
                        ...clone
                    },
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
        } else {
            let clone = {...filters};
            delete clone.q;
            setFilters(clone);
                props.dispatch(messagesActions.getMessages({
                    token: Biscuit.get('token'),
                    filter: {
                        ...clone
                    },
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
        }

        _queryState.timeStamp = Number(moment().format('x'));
        _queryState.value = query;
    };

    const closeMessageEdit = () => {
        setToggleMessage(false);
    }

    const onChangeStatusMessage = (e, message) => {
        const mstatus = e.target.value;
        props.dispatch(messagesActions.patchMessage({
            id: message.id,
            mstatus,
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    "Accept-Language": language,
                    "Content-Language": language
                }
            }
        }));
        props.dispatch(messagesActions.getMessages({
            token: Biscuit.get('token'),
            filter: {
                limit: 100,
                page: 1,
                sort: 'created',
                direction: 'desc'
            },
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));
    }
    const onFilterChanged = (filter) => {

        const _filter = {'sort': 'modified','direction': 'desc'};
        let clone = {...filter};

        Object.assign(clone,_filter);
        setFilters(clone);
        props.dispatch(messagesActions.getMessages({
            token: Biscuit.get('token'),
            filter: clone,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setMessagesPending(true);
    };

    const handleOpenMultipleRecipientsDialog = (message) => {
        setToggleMultipleRecipients(true);
        const recipientsArr = message.recipient.split(";");
        const recipientsInfoArr = [];
        let userInfo = []
        recipientsArr.map(item => {
            userInfo = users.filter(userItem => (userItem.id.includes(item)));
            recipientsInfoArr.push({
                customer_nbr: userInfo[0].customer_nbr,
                user: userInfo[0].first_name + " " + userInfo[0].last_name,
                to: userInfo[0].id,
                cate: userInfo[0].role === "user" ? "user" : "staff",
            })
        })
        setMultipleRecipientList(recipientsInfoArr);
    };

    const handleCloseMultipleRecipientsDialog = () => {
        setToggleMultipleRecipients(false)
    }

    const onChangeSort = (ev) => {

        const el = ev.currentTarget;

        const sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

        if (sortKey) {
            let filter = {
                sort: sortKey,
                direction: direction
            };

            setFilters(Object.assign(filters, filter));
            if(props.status.action === 'usergroups'){
                props.dispatch(membershipTypeActions.getMembershipTypes({
                    token: Biscuit.get('token'),
                    filter: filters,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
            }else if(props.status.messagesAction === "messages"){
                props.dispatch(messagesActions.getMessages({
                    token: Biscuit.get('token'),
                    filter: filters,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
            }else {
                props.dispatch(userActions.getUsers({
                    token: Biscuit.get('token'),
                    filter: filters,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
            }
            const activeSortTab = $('.is-active');

            for (var tab=0;tab<activeSortTab.length;tab++) {
                activeSortTab[tab].classList.remove('is-active');
            }
            /*
            _.each(activeSortTab, function(key,value){
              key.classList.remove('is-active');
            });
            */
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
        }
    };

    const getNameOfRecipient = (recipient) => {
        const userInfo = users.filter(userItem => (userItem.id.includes(recipient)));
        const nameRecipient = (userInfo !== null && userInfo.length > 0) ? userInfo[0]?.first_name + " " + userInfo[0]?.last_name : "";
        const roleRecipient = userInfo[0]?.role;
        return {
            nameRecipient,
            roleRecipient
        };
    };

    const getUserIdOfRecipient = (recipient) => {
        const userInfo = users.filter((userItem) =>
            userItem.id.includes(recipient)
        );
        const userId =
            userInfo !== null && userInfo.length > 0 ? userInfo[0]?.id : "";
        const roleRecipient = userInfo[0]?.role;
        return {
            userId,
            roleRecipient,
        };
    };

    const onDeleteMessage = (message,key) => {
        // show warning
        if (confirm(t('really_remove'))) {
            props.dispatch(messagesActions.deleteMessage({
                id: message.id,
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setDeleteMessagePending(key);
        }
    };

    const getAvailableStatusMessage = () => {
        return ['success', 'failed', 'draft', 'paused'];
    }

    const getAvailableTypeRecipient = () => {
        return ['allUsers', 'userID', 'userGroup'];
    }

    const getAvailableTypeNotification = () => {
        return ['toast', 'popup'];
    }

    const getNameOfUsergroup = (usergroup) => {
        const usergroupInfo = userGroups.filter((usergroupItem) =>
            usergroupItem.id.toString().includes(usergroup.toString())
        );
        const nameUsergroup =
            usergroupInfo !== null && usergroupInfo.length > 0
                ? usergroupInfo[0]?.name
                : "";
        return nameUsergroup;
    };

    const loadNextPage = (page) => {
             // request next page
            props.dispatch(messagesActions.getMessages({
                token: Biscuit.get('token'),
                filter: {
                    ...filters,
                    page: page,
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setMessagesPending(true);
    };

    const submenuItems = [
        {
            name: t('users',null,'capital'),
            link: 'users',
            data_inb_val: 'users',
            icon: 'fi fi-address-book',
            isActive: false,
            isAccessible: isViewVisible('users','users')
        },{
            name: t('staff',null,'capital'),
            link: 'users/staff',
            data_inb_val: 'staff',
            icon: 'fi fi-torsos-all',
            isActive: false,
            isAccessible: isViewVisible('staff','users')
        },{
            name: t('usergroups',null,'capital'),
            link: 'usersExtension/userGroups',
            data_inb_val: 'groupList',
            icon: 'fi fi-torsos-all',
            isActive: false,
            isAccessible: isViewVisible('groupList','users')
        },{
            name: t('messages',null,'capital'),
            link: 'usersExtension/messages',
            data_inb_val: 'messages',
            icon: 'fi fi-mail',
            isActive: true,
            isAccessible: isViewVisible('messages','users')
        }
    ];

    const  tabs = [
        {
            name: t('date', null, 'capital'),
            smallWidth: 6,
            mediumWidth: 2,
            title: t('date', null, 'capital'),
            canSort: true,
            sort: {
                direction: 'desc',
                data_inb_val: 'modified'
            }
        },
        {
            name: t('subject', null, 'capital'),
            smallWidth: 6,
            mediumWidth: 3,
            title: t('subject', null, 'capital'),
            canSort: true,
            sort: {
                direction: 'asc',
                data_inb_val: 'subject'
            }
        },{
            name: t('order_nbr', null, 'capital'),
            smallWidth: 6,
            mediumWidth: 1,
            title: t('order_nbr', null, 'capital'),
        },{
            name: t('recipient', null, 'capital'),
            smallWidth: 6,
            mediumWidth: 2,
            title: t('recipient', null, 'capital'),
        }, {
            name: t('type', null, 'capital'),
            smallWidth: 6,
            mediumWidth: 1,
            title: t('sort_by_${a}', {a: t('type')}, 'capital'),
            canSort: true,
            sort: {
                direction: 'asc',
                data_inb_val: 'mtype'
            }
        }, {
            name: t('status'),
            smallWidth: 6,
            mediumWidth: 1,
            title: t('sort_by_${a}', {a: t('status')}, 'capital'),
            canSort: true,
            sort: {
                direction: 'asc',
                data_inb_val: 'mstatus'
            }
        }
    ];

    let ownRole = Biscuit.get('user.role');
    /*
       Roles gradation  lowest to highest
       0: user
       1: garage-staff
       2: manager-location
       3: mediator
       4: booking-manager
       5: manager
       6: admin
     */
    let roleGradiations = {
        0: 'user',
        1: 'garage-staff',
        2: 'manager-location',
        3: 'mediator',
        4: 'booking-manager',
        5: 'manager',
        6: 'admin'
    };
    let roleGradiationsRevers = {
        'user':0,
        'staff':1,
        'manager-location':2,
        'mediator':3,
        'booking-manager':4,
        'manager':5,
        'admin':6
    };

    let roles = [];
    for(let i = 0; i <= roleGradiationsRevers[ownRole]; i++){
        if(i===0){
            if(ownRole !== 'staff') {
                roles.push(roleGradiations[i]);
            }
        } else {
            roles.push(roleGradiations[i]);
        }
    }
    const getAvailableRoles = () => {

        //  let roles = ['admin','manager','booking-manager','mediator','manager-location','garage-staff'];         // these roles are always visible (admin is only selectable by other admins)

        //if (props.status.action != 'staff') roles.push('user');                                   // user is only hidden in sidebar filter

        //if (Biscuit.get('client.isVehicleOwner') === 'true') roles.push('manager-location');      // only vehicle owner have location managers

        // if (Number(Biscuit.get('user.client_id')) == 28 || Number(Biscuit.get('user.client_id')) == 49 || Number(Biscuit.get('user.client_id')) == 50) roles.push();              // only client 28 is using this role for now

        return roles;
    }

    return (
        <>
            {!toggleMessage && params.messageId === null && !params.add &&
                <>
                    <MessageSidebar
                        setSelectedFilter={onFilterChanged}
                        getAvailableStatusMessage={getAvailableStatusMessage}
                        dispatch={dispatch}
                        setToggleMessage={setToggleMessage}
                        messageSummaryPending={messageSummaryPending}
                        messageSummary={messageSummary}
                    />
                </>
            }
            <div id="inb-c-main" className="columns user">
                {!toggleMessage &&
                    <>
                        <InboomaSubmenu
                            tabs={submenuItems}
                            searchbar={true}
                            extraClasses={"sticky-top"}
                            searchbarPlaceholder={t('order_nbr') + ' / ' + t('subject')}
                            searchbarValue={allUrlParams?.q !== undefined ? allUrlParams.q : ""}
                            searchbarHandler={onSearchbarChanged}
                            smallOnlyTitle={t('messages',null,'capital')}
                            pagination={pagination}
                            itemsCountPerPage={100}
                            pageRangeDisplayed={5}
                            onChange={loadNextPage}
                            initialized={initialized}
                            itemLength={messages.length}
                        />

                        <SortNav
                            tabs={tabs}
                            extraClasses={"sticky-top-sortbar"}

                            handler={onChangeSort}
                        />
                        {/*{typeof pagination !== 'undefined' &&
                            <Paginator
                                pagination={pagination}
                                itemsCountPerPage={100}
                                pageRangeDisplayed={5}
                                onChange={loadNextPage}
                                upper={true}
                            />}*/}
                        <div className="off-canvas-wrapper">
                        {messages.length > 0 && !messagesPending && params.messageId === null && !params.add && !userGroupsPending && _userGroups.success !== '' &&
                           <MessagesList
                               messages={messages}
                               handleOpenMultipleRecipientsDialog={handleOpenMultipleRecipientsDialog}
                               deleteMessagePending={deleteMessagePending}
                               onDeleteMessage={onDeleteMessage}
                               currentUrl={currentUrl}
                               getNameOfRecipient={getNameOfRecipient}
                               getUserIdOfRecipient={getUserIdOfRecipient}
                               getNameOfUsergroup={getNameOfUsergroup}
                               onChangeStatusMessage={onChangeStatusMessage}
                               handleCloseMultipleRecipientsDialog = {handleCloseMultipleRecipientsDialog}
                               toggleMultipleRecipients = {toggleMultipleRecipients}
                               multipleRecipientList = {multipleRecipientList}
                               />
                        }
                        {!messagesPending && messages.length < 1 &&
                            <>
                                <div
                                    id="inb-app-collection-empty"
                                    className="inb-announcement"
                                    style={{minHeight: "1150px"}}
                                >
                                    <div className="inb-image-box">
                                        <img alt="No Data" src={"assets/img/no_data.svg"}/>
                                    </div>
                                    <h3>
                                        {t('app_msg_collection_empty')}
                                    </h3>
                                    <p>
                                        {t('app_msg_collection_empty_body')}
                                    </p>
                                </div>
                            </>}
                        {messagesPending && <Loader
                            mediumWidth={2}
                            smallWidth={4}
                            subLoaders={5}/>}
                        </div>
                    </>
                }
            {toggleMessage && !clientPending && client !== null &&
                <MessageEdit
                    client={client}
                    message={message}
                    closeMessageEdit={closeMessageEdit}
                    dispatch={dispatch}
                    showNotification={showNotification}
                />
            }
            </div>
            {(((params.messageId !== null && !messagePending) || params.add) && _matrixFields.data.length > 0) && !usersPending &&
                <MessageView
                    message={message}
                    users={users}
                    matrixFields={_matrixFields.data}
                    showNotification={showNotification}
                    requestPath={returnPath}
                    dispatch={dispatch}
                    getAvailableTypeRecipient={getAvailableTypeRecipient}
                    getAvailableTypeNotification={getAvailableTypeNotification}
                    getAvailableRoles={getAvailableRoles}
                />
            }
        </>
    )
}

export default MessagesView;